import { Table } from 'antd'
import React, { useMemo } from 'react'

const InternalAssessmentTable = ({ ratingDetails }) => {
  const transformedData = useMemo(() => {
    if (!ratingDetails?.details) return []

    const selfEval =
      ratingDetails.details.find(e => e.evaluatorType === 'self') || {}
    const managerEval =
      ratingDetails.details.find(e => e.evaluatorType === 'manager') || {}
    const editorEval =
      ratingDetails.details.find(e => e.evaluatorType === 'editor') || {}

    return [
      {
        key: '1',
        label: 'discipline_score',
        content: 'Ý thức tổ chức kỷ luật',
        maxPoints: 20,
        selfEvaluation: selfEval.disciplineScore || null,
        departmentEvaluation: managerEval.disciplineScore || null,
        editorialEvaluation: editorEval.disciplineScore || null,
      },
      {
        key: '2',
        label: 'skill_score',
        content: 'Năng lực, Kỹ năng',
        maxPoints: 20,
        selfEvaluation: selfEval.skillScore || null,
        departmentEvaluation: managerEval.skillScore || null,
        editorialEvaluation: editorEval.skillScore || null,
      },
      {
        key: '3',
        label: 'performance_score',
        content: 'Kết quả thực hiện nhiệm vụ được giao',
        maxPoints: 50,
        selfEvaluation: selfEval.performanceScore || null,
        departmentEvaluation: managerEval.performanceScore || null,
        editorialEvaluation: editorEval.performanceScore || null,
      },
      {
        key: '4',
        label: 'bonus_score',
        content: 'Điểm thưởng',
        maxPoints: 10,
        selfEvaluation: selfEval.bonusScore || null,
        departmentEvaluation: managerEval.bonusScore || null,
        editorialEvaluation: editorEval.bonusScore || null,
      },
      {
        key: '5',
        label: 'total_score',
        content: 'Cộng điểm',
        maxPoints: 100,
        selfEvaluation: selfEval.totalScore === 0 ? null : selfEval.totalScore,
        departmentEvaluation:
          managerEval.totalScore === 0 ? null : managerEval.totalScore,
        editorialEvaluation:
          editorEval.totalScore === 0 ? null : editorEval.totalScore,
      },
      {
        key: '6',
        label: 'bonus_reason',
        content: 'Lý do thưởng',
        selfEvaluation: selfEval.bonusReason || null,
        departmentEvaluation: managerEval.bonusReason || null,
        editorialEvaluation: editorEval.bonusReason || null,
      },
      {
        key: '7',
        label: 'bonus_amount',
        content: 'Nhuận bút (đồng)',
        selfEvaluation: selfEval.bonusAmount || null,
        departmentEvaluation: managerEval.bonusAmount || null,
        editorialEvaluation: editorEval.bonusAmount || null,
      },
      {
        key: '8',
        label: 'article_count',
        content: 'Số lượng tin, bài',
        selfEvaluation: selfEval.articleCount || null,
        departmentEvaluation: managerEval.articleCount || null,
        editorialEvaluation: editorEval.articleCount || null,
      },
      {
        key: '9',
        label: 'file_count',
        content: 'Số đề tài/ Phóng sự',
        selfEvaluation: selfEval.fileCount || null,
        departmentEvaluation: managerEval.fileCount || null,
        editorialEvaluation: editorEval.fileCount || null,
      },
      {
        key: '10',
        label: 'district_articles',
        content: 'Bài viết về quận, huyện, ngành theo dõi',
        selfEvaluation: selfEval.districtArticles || null,
        departmentEvaluation: managerEval.districtArticles || null,
        editorialEvaluation: editorEval.districtArticles || null,
      },
      {
        key: '11',
        label: 'english_articles',
        content: 'Bài viết chuyên sâu bằng tiếng Anh(PV.HNT)',
        selfEvaluation: selfEval.englishArticles || null,
        departmentEvaluation: managerEval.englishArticles || null,
        editorialEvaluation: editorEval.englishArticles || null,
      },
      {
        key: '12',
        label: 'journalism_economics',
        content: 'Kinh tế báo chí + Đạt %',
        selfEvaluation: selfEval.journalismEconomics || null,
        departmentEvaluation: managerEval.journalismEconomics || null,
        editorialEvaluation: editorEval.journalismEconomics || null,
      },
      {
        key: '13',
        label: 'published_count',
        content: 'Số lượng báo phát hành',
        selfEvaluation: selfEval.publishedCount || null,
        departmentEvaluation: managerEval.publishedCount || null,
        editorialEvaluation: editorEval.publishedCount || null,
      },
      {
        key: '14',
        label: 'debt_collection_rate',
        content: 'Tỷ lệ thu hồi công nợ',
        selfEvaluation: selfEval.debtCollectionRate || null,
        departmentEvaluation: managerEval.debtCollectionRate || null,
        editorialEvaluation: editorEval.debtCollectionRate || null,
      },
    ]
  }, [ratingDetails])

  const columns = [
    {
      title: 'STT',
      dataIndex: 'key',
      width: 50,
      align: 'center',
    },
    {
      title: 'Nội dung tiêu chí chấm điểm',
      dataIndex: 'content',
      width: 200,
      render: (value, record) => (
        <span
          style={record.label === 'total_score' ? { fontWeight: 'bold' } : {}}>
          {value}
        </span>
      ),
    },
    {
      title: 'Điểm tối đa',
      dataIndex: 'maxPoints',
      width: 100,
      align: 'center',
      render: (value, record, index) => {
        if (index >= 5) return { children: null, props: { colSpan: 0 } }
        return (
          <span
            style={
              record.label === 'total_score' ? { fontWeight: 'bold' } : {}
            }>
            {value}
          </span>
        )
      },
    },
    {
      title: 'Cá nhân tự đánh giá',
      dataIndex: 'selfEvaluation',
      align: 'center',
      width: 100,
      render: (value, record, index) => {
        if (index >= 5)
          return {
            children: <span> {value === '0' ? null : value}</span>,
            props: { colSpan: 2 },
          }
        return (
          <span
            style={
              record.label === 'total_score' ? { fontWeight: 'bold' } : {}
            }>
            {value === '0' ? null : value}
          </span>
        )
      },
    },
    {
      title: 'Trưởng phòng/ban Chấm',
      dataIndex: 'departmentEvaluation',
      width: 200,
      align: 'center',
      render: (value, record, index) => {
        if (index >= 5)
          return {
            children: <span>{value === '0' ? null : value}</span>,
            props: { colSpan: 1 },
          }
        return (
          <span
            style={
              record.label === 'total_score' ? { fontWeight: 'bold' } : {}
            }>
            {value === '0' ? null : value}
          </span>
        )
      },
    },
    {
      title: 'Ban biên tập chấm',
      dataIndex: 'editorialEvaluation',
      align: 'center',
      width: 200,
      render: (value, record, index) => {
        if (index >= 5)
          return {
            children: <span> {value === '0' ? null : value}</span>,
            props: { colSpan: 1 },
          }
        return (
          <span
            style={
              record.label === 'total_score' ? { fontWeight: 'bold' } : {}
            }>
            {value === '0' ? null : value}
          </span>
        )
      },
    },
  ]

  return (
    <Table
      columns={columns}
      dataSource={transformedData}
      pagination={false}
      bordered
      size="middle"
      scroll={{ x: 'max-content' }}
    />
  )
}

export default InternalAssessmentTable
